import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiDeleteOrder, apiGetOrderData, apiPutOrder } from 'services/OrderService'

export const getOrder = createAsyncThunk('orderEdit/data/getOrder', async (data) => {
    const response = await apiGetOrderData(data)
    return response.data
})

export const updateOrder = async (data) => {
    const response = await apiPutOrder(data)
    return response.data
}

export const deleteOrder = async (data) => {
    const response = await apiDeleteOrder(data)
    return response.data
}

const dataSlice = createSlice({
    name: 'orderEdit/data',
    initialState: {
        loading: false,
        orderData: [],
    },
    reducers: {
        resetOrderData: (state, action) => {
            state.orderData = []
        },
    },
    extraReducers: (builder) => {
		builder.addCase(getOrder.fulfilled, (state, action) => {
            state.orderData = action.payload.order
            state.loading = false
        })
        builder.addCase(getOrder.pending, (state) => {
            state.loading = true
        })
    }
})

export const { resetOrderData } = dataSlice.actions

export default dataSlice.reducer
